<dx-box direction="col" width="100%" height="100%">
  <dxi-item [ratio]="0" [shrink]="0" [baseSize]="'auto'">
    <dx-toolbar #toolbar [items]="toolbarItems"></dx-toolbar>
  </dxi-item>

  <dxi-item [ratio]="1" [shrink]="1" [baseSize]="'auto'">
    <app-daily-checks-details-tabs #details [modelId]="modelId"></app-daily-checks-details-tabs>
  </dxi-item>
</dx-box>
